export const state = {
  appName: 'Voice TV - Membership Portal',
  appVerifier: null,
  confirmationResult: null,
  user: null,
  error: null,
  loading: false,
}

